import axios from '@/plugins/axiosInstance'
import { socialMedia } from '@/networking/urlManager'

/**
 * Checks authentication status for all integrations
 * @param {string} assetId - The asset ID
 * @returns {Promise<Array>} List of connected platforms
 */
export const checkAuth = async (assetId) => {
  try {
    const response = await axios.get(socialMedia.checkSocialAuth, {
      params: {
        assetId,
      },
    })
    return response.data.data || []
  } catch (error) {
    throw error
  }
}
